module.exports = __webpack_public_path__ + "b.no2.b695a3f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/b.no2.jpg
// module id = u/8+
// module chunks = 0